export const generateCodeSnippet = (token: string) => `
  <script>
    (function(w, d, t, k, r, h, s, p) {
      w[k]=h,s=d.createElement(t),p=d.getElementsByTagName(t)[0],s.async=1,s.src=r,p.parentNode.insertBefore(s,p)
    })(window, document, "script", "MAToken", "${process.env.REACT_APP_SCRIPT_URL}", "${token}")
  </script>
`;

// export const generateCodeSnippet = (token: string) => `<script>${token}</script>`;
